import { Box, Flex, Tag, TagLabel } from '@chakra-ui/react';
import { Row } from '@tanstack/react-table';
import { useRouter } from 'next/router';
import { CreatorGender } from '~/clientApi/creator.model';
import { EmptyCell } from '~/screens/WhalarModeScreen/components/Table/Columns';
import {
  creatorMarketerListRowTrackId,
  myAgencyListRowTrackId,
} from '~/screens/WhalarModeScreen/components/Table/constants';
import { cellContainer } from '~/screens/WhalarModeScreen/components/Table/styles';
import { useHover } from '~/screens/WhalarModeScreen/hooks/useHover';
import customTheme from '~/styles/theme';
import { ICreator } from '~/types';

//TODO: This component should be refactored and use GenderTag generic component
// that we  have in src/components folder

interface Props {
  row: Row<ICreator>;
}

export const Gender: React.FC<Props> = ({ row }) => {
  const [hoverElemRef] = useHover<HTMLDivElement>();
  const { genderAgency: gender } = row.original;
  const { value: text, color } = getGenderFromValue(
    (gender as string)?.charAt(0),
  );
  const { pathname } = useRouter();
  const isCreatorMarketerRoster = pathname.includes('/talent');

  return (
    <Box ref={hoverElemRef} {...cellContainer}>
      {gender ? (
        <Flex>
          <Tag
            size="md"
            width="24px"
            height="24px"
            fontSize="sm"
            borderRadius="full"
            variant="outline"
            justifyContent="center"
            color={color}
            colorScheme={color}
            border={`1px solid ${color}`}
            track-id={
              isCreatorMarketerRoster
                ? creatorMarketerListRowTrackId.creatorGender
                : myAgencyListRowTrackId.creatorGender
            }
          >
            <TagLabel overflow="initial">{text}</TagLabel>
          </Tag>
        </Flex>
      ) : (
        <EmptyCell content="-" />
      )}
    </Box>
  );
};

export const genders: CreatorGender[] = ['Female', 'Male', 'Non Binary'];

export const genderOptions = {
  Female: {
    value: 'F',
    name: 'Female',
    color: customTheme.colors.tertiary[600],
  },
  Male: { value: 'M', name: 'Male', color: customTheme.colors.lightBlue[700] },
  'Non Binary': {
    value: 'NB',
    name: 'Non Binary',
    color: customTheme.colors.beige[700],
  },
};

export const getGenderFromValue = (gender: string) => {
  switch (gender) {
    case 'M':
      return genderOptions.Male;
    case 'F':
      return genderOptions.Female;
    default:
      return genderOptions['Non Binary'];
  }
};
